export const RESET_DEVICE_MESSAGE = "RESET_DEVICE_MESSAGE_CSV";

export const EXPORT_FOR_FACILITIES = "EXPORT_FOR_FACILITIES"
export const EXPORT_FOR_PATIENTS_FACILITY = "EXPORT_FOR_PATIENTS_FACILITY"
export const EXPORT_FOR_SENSOR = "EXPORT_FOR_SENSOR"

export const GET_EXPORTED_LINK_SUCCESSFULLY = "GET_EXPORTED_LINK_SUCCESSFULLY"
export const GET_EXPORTED_LINK_FAILED = "GET_EXPORTED_LINK_FAILED" 
